import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private refreshProfileSubject = new Subject<void>();

  refreshProfile$ = this.refreshProfileSubject.asObservable();

  triggerProfileRefresh() {
    this.refreshProfileSubject.next();
  }
}
